<template>
  <div class="exam-content">

    <!-- === Demande d'examen === -->
    <div class="exam-form" v-if="leleve.demandexam === 'null' || leleve.exam === '' || this.dateProb !== null">

      <div class="exam-warn" v-if="this.dateProb !== null && this.dateProb > this.nowDate">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" style="flex-shrink:0;margin-top:1px"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <p>Suite à un échec ou une annulation, cet élève est censé attendre le <strong>{{ dateProb.toLocaleDateString('fr-FR') }}</strong> avant de faire une nouvelle demande. Êtes-vous sûr de vouloir en faire une nouvelle ?</p>
      </div>

      <div class="exam-fields">
        <div class="ex-field">
          <label class="ex-label">Moniteur favori</label>
          <select name="mono" id="mono" v-model="mono" class="ex-select">
            <option value="">Choisir le moniteur favori</option>
            <template v-for="m in this.moniteurs" :key="m.id">
              <option :value="m.idMono">{{ m.nom }} {{ m.prenom }}</option>
            </template>
          </select>
        </div>

        <div class="ex-field">
          <label class="ex-label">Lieu d'examen</label>
          <MultiSelect
            class="ex-multiselect"
            v-model="lieu"
            :options="lieux"
            optionValue="id"
            optionLabel="nom"
            placeholder="Choisir le lieu d'examen"
            :disabled="desac"
          />
        </div>
      </div>

      <div class="ex-field">
        <label class="ex-label">Commentaire <span class="ex-optional">(optionnel)</span></label>
        <textarea v-model="commentaire" name="commentaire" id="commentaire" class="ex-textarea" placeholder="Saisir un commentaire..."></textarea>
      </div>

      <div class="ex-actions">
        <template v-if="leleve.demandexam === 'null'">
          <button v-if="!loadingBtn" class="ex-btn ex-btn--primary" @click="setDemande('null')">
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Valider la demande
          </button>
          <button v-else class="ex-btn ex-btn--primary" disabled>
            <i class="fa fa-spinner fa-spin"></i> Valider
          </button>
        </template>
        <template v-else>
          <button v-if="!loadingBtn" class="ex-btn ex-btn--primary" @click="setDemande(leleve.demandexam)">
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Valider la demande
          </button>
          <button v-else class="ex-btn ex-btn--primary" disabled>
            <i class="fa fa-spinner fa-spin"></i> Valider
          </button>
        </template>
      </div>
    </div>

    <!-- === Passage examen === -->
    <div class="exam-passage" v-else-if="leleve.examId !== 'null'">
      <div class="passage-header">
        <template v-if="showCancelExam === false">
          <div class="passage-title">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/></svg>
            Saisir le résultat
          </div>
          <button class="ex-btn ex-btn--ghost" @click="this.showCancelExam = true;">Annuler l'examen</button>
        </template>
        <template v-else>
          <div class="passage-title passage-title--cancel">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            Annulation de l'examen
          </div>
          <button class="ex-btn ex-btn--ghost" @click="this.showCancelExam = false;">Saisir le résultat</button>
        </template>
      </div>

      <div class="passage-content" v-if="showCancelExam === false">
        <div class="ex-field">
          <label class="ex-label">Score obtenu</label>
          <input type="number" name="score" id="score" v-model="score" class="ex-input" placeholder="Score / 35">
        </div>
        <label class="ex-checkbox-label">
          <input type="checkbox" name="elimi" id="elimi" v-model="elim" class="ex-checkbox">
          <span>Éliminatoire</span>
        </label>
        <template v-if="(score !== null && score < 20) || elim === true">
          <div class="ex-field">
            <label class="ex-label">Date d'attente</label>
            <input type="date" name="dateAtt" id="dateAtt" v-model="dateAtt" class="ex-input">
          </div>
        </template>
        <div class="ex-actions">
          <button class="ex-btn ex-btn--primary" @click="updatePassage">
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Valider
          </button>
        </div>
      </div>

      <div class="passage-content" v-else>
        <div class="ex-field">
          <label class="ex-label">Annulé par</label>
          <select name="cancelBy" id="cancelBy" v-model="cancel" class="ex-select">
            <option value="">Annulé par</option>
            <option value="eleve">Élève</option>
            <option value="agence">Agence</option>
            <option value="préfecture">Préfecture</option>
          </select>
        </div>
        <template v-if="cancel === 'eleve'">
          <div class="ex-field">
            <label class="ex-label">Date d'attente</label>
            <input type="date" name="dateAtt" id="dateAtt" v-model="dateAtt" class="ex-input">
          </div>
        </template>
        <div class="ex-actions">
          <button class="ex-btn ex-btn--danger" @click="updatePassage">
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            Confirmer l'annulation
          </button>
        </div>
      </div>
    </div>

    <!-- === En attente === -->
    <div class="exam-waiting" v-else>
      <svg width="32" height="32" fill="none" viewBox="0 0 24 24" style="color:#94a3b8"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M12 7v5l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      <p>En attente d'attribution d'un examen</p>
    </div>

  </div>
</template>

<script>

export default {

  props: [
    "eleve",
    "moniteurs",
    "updateEleve"
  ],

  components: {

  },

  data() {
    return {
        lieux : [],
        leleve : "",
        mono : "",
        lieu : "",
        commentaire : "",
        score : null,
        elim : false,
        cancel : "",
        dateCancel : null,
        dateAtt : null,
        showShortList : false,
        showCancelExam : false,
        cancelExam : "",
        loadingBtn : false,
        dateProb : null,
        nowDate : null,
    };
  },

  mounted() {
    this.getLieuxExam();
    this.leleve = this.eleve;

    if(this.eleve.examId !== "null"){
      this.getExamInfo();
    }

    if(this.eleve.demandexam === 'null' || this.eleve.exam === ''){
        this.checkSoldeForDemande();
    }

  },

  methods: {

    checkSoldeForDemande(){
        window.api
          .get(
            "/can/demande/"+this.eleve.id,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            if(response.data.demande === false){
              alert("L'élève n'a pas un solde suffisant pour pouvoir demander une date d'examen, il doit avoir au minimum "+response.data.limite+"€ en solde");
              window.location.reload();
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },

    updatePassage(){
      if(this.showCancelExam === false){
        if(this.score === null || this.score === ""){
          alert("Veuillez saisir le résultat");
        }else if(this.score < 20 || this.elim === true){
          if(this.dateAtt === null){
            alert("Veuillez saisir la date d'attente");
          }else{
            if (window.confirm("Êtes-vous sûr de vouloir saisir ce score ?")){
              window.api
                .post(
                  "/set/passage/exam/" + this.leleve.passage.idp + "/add",
                  {
                    score: this.score,
                    eliminatoire: this.elim,
                    dateAtt: this.dateAtt,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  }
                )
                .then(() => {
                  window.location.reload();
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }
        }else{
          if (window.confirm("Êtes-vous sûr de vouloir saisir ce score ?")){
            window.api
              .post(
                "/set/passage/exam/" + this.leleve.passage.idp + "/add",
                {
                  score: this.score,
                  eliminatoire: this.elim,
                  dateAtt: this.dateAtt,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                }
              )
              .then(() => {
                window.location.reload();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      }else{
        if(this.cancel === ""){
          alert("Veuillez saisir la partie annulant l'examen pour l'élève");
        }else if(this.cancel === "eleve" && this.dateAtt === null || this.dateAtt === ""){
          alert("Veuilelz saisir la date d'attente");
        }else{
          if (window.confirm("Êtes-vous sûr de vouloir annuler la participation de cet élève à l'examen ?")){
            window.api
              .post(
                "/set/passage/exam/" + this.leleve.passage.idp + "/cancel",
                {
                  cancelBy: this.cancel,
                  dateAtt: this.dateAtt,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                }
              )
              .then(() => {
                window.location.reload();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      }
    },

    getExamInfo(){
        window.api
          .get(
            "/passage/exam/eleve/info/"+this.eleve.id+"/"+this.eleve.examId+"/",
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.leleve.passage = response.data.passageInfo;
            this.score = response.data.passageInfo.score;
            this.elim = response.data.passageInfo.eli;
            this.dateAtt = response.data.passageInfo.dateAtt;
            if(this.dateAtt !== null){
              this.dateProb = new Date(this.dateAtt);
              this.nowDate = new Date();
              this.checkSoldeForDemande();
            }
            if(response.data.passageInfo.cancelBy !== null){
              this.cancel = response.data.passageInfo.cancelBy;
              this.dateCancel = response.data.passageInfo.cancelDate;
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },

    setDemande(type){
        this.loadingBtn = true;
        if(this.mono === ""){
            alert("Veuillez choisir un moniteur");
            this.loadingBtn = false;
        }else if(this.lieu === ""){
            alert("Veuillez choisir un lieu");
            this.loadingBtn = false;
        }else{
            if (window.confirm("Êtes-vous sûr de demander une date d'examen pour cet élève ?")){
              window.api
                .post(
                  "/set/demande/exam/" + type + "/null",
                  {
                    id: this.leleve.id,
                    ids: this.$store.state.user.id,
                    idMono: this.mono,
                    lieu: this.lieu,
                    commentaire: this.commentaire,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  }
                )
                .then((response) => {
                  this.leleve.exam = "En attente";
                  this.leleve.examId = "null";
                  this.dateProb = null;
                  this.leleve.demandexam = response.data.id;
                  this.loadingBtn = false;
                  this.$emit("updateEleve", this.leleve);
                })
                .catch((error) => {
                  console.log(error);
                });
            }else{
              this.loadingBtn = false;
            }
        }
    },

    getLieuxExam(){
      window.api
        .get(
          "/boite/lieu/exam/",
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.lieux = response.data.lieux;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.exam-content {
  padding: 4px 0 8px;
}

/* ── Warning ── */
.exam-warn {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 16px;
  background: #fef3c7;
  border: 1.5px solid #fde68a;
  border-radius: 10px;
  font-size: 13px;
  color: #92400e;
}
.exam-warn p { margin: 0; line-height: 1.5; }

/* ── Form ── */
.exam-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.exam-fields {
  display: flex;
  gap: 16px;
}

.ex-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.ex-label {
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: .05em;
}

.ex-optional {
  font-weight: 400;
  text-transform: none;
  color: #94a3b8;
  letter-spacing: 0;
}

.ex-select {
  width: 100%;
  padding: 10px 36px 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  color: #1a1f2e;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 12px center;
  -webkit-appearance: none;
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
}
.ex-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }

.ex-multiselect {
  border: 1.5px solid #e2e8f0 !important;
  border-radius: 10px !important;
}

.ex-textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  color: #1a1f2e;
  background: #fff;
  outline: none;
  transition: border-color .15s;
  resize: vertical;
  min-height: 76px;
  box-sizing: border-box;
}
.ex-textarea:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }

.ex-input {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  color: #1a1f2e;
  background: #fff;
  outline: none;
  transition: border-color .15s;
  box-sizing: border-box;
}
.ex-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }

/* ── Buttons ── */
.ex-actions { display: flex; gap: 10px; margin-top: 4px; }

.ex-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all .15s;
  font-family: inherit;
}
.ex-btn--primary { background: #3b82f6; color: #fff; }
.ex-btn--primary:hover:not(:disabled) { background: #2563eb; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59,130,246,.3); }
.ex-btn--danger { background: #ef4444; color: #fff; }
.ex-btn--danger:hover:not(:disabled) { background: #dc2626; }
.ex-btn--ghost { background: transparent; color: #64748b; border: 1.5px solid #e2e8f0; }
.ex-btn--ghost:hover:not(:disabled) { background: #f8fafc; }
.ex-btn:disabled { opacity: .5; cursor: not-allowed; }

/* ── Passage examen ── */
.exam-passage { display: flex; flex-direction: column; gap: 0; }

.passage-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1.5px solid #e2e8f0;
  margin-bottom: 20px;
}

.passage-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1f2e;
}
.passage-title--cancel { color: #dc2626; }

.passage-content { display: flex; flex-direction: column; gap: 16px; }

.ex-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
}
.ex-checkbox { width: 16px; height: 16px; accent-color: #3b82f6; cursor: pointer; }

/* ── En attente ── */
.exam-waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 0;
  color: #94a3b8;
  font-size: 14px;
}

@media (max-width: 540px) {
  .exam-fields { flex-direction: column; }
}
</style>
